import React from "react";
import { connect } from "react-redux";

import { Route, Switch, useRouteMatch } from "react-router-dom";

import User from "@mapmycustomers/shared/types/User";

import ViewType from "@app/scene/dashboard/enum/ViewType";
import dashboardAnalytics from "@app/scene/dashboard/utils/dashboardAnalytics";
import { getCurrentUser } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";
import AnalyticsContext from "@app/util/contexts/AnalyticsContext";

import DashboardPage from "./DashboardPage";

interface Props {
  currentUser: undefined | User;
}

const Dashboard: React.FC<Props> = ({ currentUser }) => {
  const { path } = useRouteMatch();

  if (!currentUser) {
    return null; // not yet loaded probably
  }

  const viewType = `:viewType(${Object.values(ViewType).join("|")})`;

  return (
    <AnalyticsContext.Provider value={dashboardAnalytics}>
      <Switch>
        <Route
          path={[
            // must be in this order in order to match from the most to less specific paths
            // can be a single path regex too, but I think it's easier to read when it's separated
            `${path}/teams/:teamId/users/:userId/${viewType}`,
            `${path}/teams/:teamId/users/:userId`,
            `${path}/teams/:teamId/${viewType}`,
            `${path}/teams/:teamId`,
            `${path}/users/:userId/${viewType}`,
            `${path}/users/:userId`,
            `${path}/${viewType}`,
            path,
          ]}
        >
          <DashboardPage />
        </Route>
      </Switch>
    </AnalyticsContext.Provider>
  );
};

const mapStateToProps = (state: RootState) => ({
  currentUser: getCurrentUser(state),
});

export default connect(mapStateToProps)(Dashboard);
